import { useEffect } from "react";

export default function usePageMeta({ title, description, canonical }) {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      const tag = document.querySelector("meta[name='description']");
      if (tag) tag.setAttribute("content", description);
    }

    if (canonical) {
      let tag = document.querySelector("link[rel='canonical']");
      if (!tag) {
        tag = document.createElement("link");
        tag.setAttribute("rel", "canonical");
        document.head.appendChild(tag);
      }
      tag.setAttribute("href", canonical);
    }

    return () => {
      document.title = "Spechs | Cleaning, Property Management & Workforce Solutions in Ireland";
      const descTag = document.querySelector("meta[name='description']");
      if (descTag)
        descTag.setAttribute(
          "content",
          "Spechs - Property management, and workforce management solutions across Ireland. From cleaning to staff scheduling and time tracking with the SPECHS app."
        );
      const canonTag = document.querySelector("link[rel='canonical']");
      if (canonTag) canonTag.setAttribute("href", "https://www.spechs.ie/");
    };
  }, [title, description, canonical]);
}
